import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import _ from 'lodash';
import moment from 'moment';

import TablaCertificacionesTraspaso from './TablaCertificacionesTraspaso';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';
import convertBase64toBlob from '../../../components/common/documentos/convertBase64toBlob';
import { descargarCSV } from '../../../components/administracion/funciones/descargarCSV';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getCantidadCertificacionesTraspasoPorFiltros from '../../../graphql/querys/rrhh/getCantidadCertificacionesTraspasoPorFiltros.graphql';
import getCertificacionesTraspasoConFiltros from '../../../graphql/querys/rrhh/getCertificacionesTraspasoConFiltros.graphql';
import eliminarCertificacionTraspaso from '../../../graphql/mutations/rrhh/eliminarCertificacionTraspaso.graphql';
import getResolucionBase64 from '../../../graphql/querys/rrhh/getResolucionBase64.graphql';
import getCertificacionTraspasosPorRango from '../../../graphql/querys/rrhh/getCertificacionTraspasosPorRango.graphql';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(getOrganismos),
  graphql(eliminarCertificacionTraspaso, {
    name: 'eliminarCertificacionTraspaso',
  })
)
class VerCertificacionesTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      currentPage: 1,
      listaTotal: [],
      lista: [],
      fechaInicial: moment().subtract(7, 'd'),
      fechaFinal: moment(),
      pagina: 1,
      cantidadPorPagina: 10,
      filtroEstado: null,
      filtroOrigen: null,
      filtroDestino: null,
      filtroNumTraspaso: null,
    };
  }

  componentDidMount() {
    this.buscarCantidadCertificaciones();
  }

  buscarCantidadCertificaciones = () => {
    let filtros = {
      estado: this.state.filtroEstado,
      idOrigen: this.state.filtroOrigen,
      idDestino: this.state.filtroDestino,
      numeroTraspaso: this.state.filtroNumTraspaso,
    };

    if (this.state.fechaInicial !== '' && this.state.fechaFinal !== '') {
      filtros = {
        ...filtros,
        fechaInicio: this.state.fechaInicial,
        fechaFin: this.state.fechaFinal,
      };
    }

    this.props.client
      .query({
        query: getCantidadCertificacionesTraspasoPorFiltros,
        variables: {
          filtros: filtros,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        this.setState(
          {
            cantidadTotal:
              res.data.getCantidadCertificacionesTraspasoPorFiltros,
          },
          () => {
            // console.log('res cantidad cert =>', res.data.getCantidadCertificacionesTraspasoPorFiltros);
            this.lanzarconsulta();
          }
        );
      })
      .catch(err => {
        console.log(
          'error a la hora de buscar la cantidad total de paginas en traspasos'
        );
        console.log(err);
        errorService(err, {
          filtros: {},
        });
      });
  };

  lanzarconsulta = () => {
    this.setState({
      loadingTabla: true,
      loading: true,
    });

    let filtros = {
      estado: this.state.filtroEstado,
      idOrigen: this.state.filtroOrigen,
      idDestino: this.state.filtroDestino,
      numeroTraspaso: this.state.filtroNumTraspaso,
    };

    if (this.state.fechaInicial !== '' && this.state.fechaFinal !== '') {
      filtros = {
        ...filtros,
        fechaInicio: this.state.fechaInicial,
        fechaFin: this.state.fechaFinal,
      };
    }

    this.props.client
      .query({
        query: getCertificacionesTraspasoConFiltros,
        variables: {
          filtros: filtros,
          pagina: this.state.pagina,
          cantidadPorPagina: this.state.cantidadPorPagina,
        },
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      })
      .then(res => {
        if (res.data && res.data.getCertificacionesTraspasoConFiltros) {
          this.setState(
            {
              listaFiltrada: res.data.getCertificacionesTraspasoConFiltros,
              loadingTabla: false,
              loading: false,
            },
            () => {
              this.ordenarLista(
                this.state.pagina,
                this.state.cantidadPorPagina
              );
            }
          );
        } else {
          throw new Error('No data received from query');
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message: 'Error a la hora de buscar las certificaciones',
          description: 'Por favor, intente nuevamente'
        });
        this.setState({
          loadingTabla: false,
          loading: false,
        });
      });
  };
  

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta Certificación?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .eliminarCertificacionTraspaso({
            variables: { _id: id },
          })
          .then(res => {
            // console.log('La respuesta del delete fue....');
            // console.log(res);

            let id = res.data.eliminarCertificacionTraspaso;
            if (id) {
              notification.warning({
                message: 'Certificacion eliminada',
                description: 'Se ha eliminado la certificacion exitosamente',
              });
            }

            yo.buscarCantidadCertificaciones();
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar la certificacion'
            );
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion de la certificacion del traspaso',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  getBase64 = archivoId => {
    this.props.client
      .query({
        query: getResolucionBase64,
        variables: {
          archivo: archivoId,
        },
      })
      .then(res => {
        // console.log('response getBase64', res);
        return this.generatePDF(archivoId, res.data.getResolucionBase64);
      })
      .catch(err => {
        console.log('ERROR AL OBTENER EL LINK');
        console.log(err);
      });
  };

  generatePDF(archivoId, data) {
    const base64PdfBlob = convertBase64toBlob(data, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  }

  onChangeFechas = date => {
    // console.log('DATE: ', date);
    if (date) {
      this.setState(
        {
          ...this.state,
          fechaInicial: date[0] ? date[0] : '',
          fechaFinal: date[1] ? date[1] : '',
        },
        () => {
          this.buscarCantidadCertificaciones();
        }
      );
    } else {
      this.setState(
        {
          ...this.state,
          fechaInicial: '',
          fechaFinal: '',
        },
        () => {
          this.buscarCantidadCertificaciones();
        }
      );
    }
  };

  descargarReporte = () => {
    // console.log('entre a descargar reporte');
    let filtros = {
      estado: this.state.filtroEstado,
      fechaInicio: this.state.fechaInicial,
      fechaFin: this.state.fechaFinal,
      idOrigen: this.state.filtroOrigen,
      idDestino: this.state.filtroDestino,
      numeroTraspaso: this.state.filtroNumTraspaso,
    };

    let fechaInicio = this.state.fechaInicial;
    let fechaFin = this.state.fechaFinal;

    this.props.client
      .query({
        query: getCertificacionTraspasosPorRango,
        variables: {
          filtros: filtros,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getCertificacionTraspasosPorRango) {
          // console.log('response descargar', res);
          let data = _.map(
            res.data.getCertificacionTraspasosPorRango,
            certificacion => {
              let numeroTraspaso = '-';
              if (certificacion.numeroCertPorTipo) {
                numeroTraspaso = certificacion.numeroCertPorTipo;
              } else if (
                certificacion.traspaso &&
                certificacion.traspaso.numero
              ) {
                numeroTraspaso = certificacion.traspaso.numero;
              }

              return {
                NUMERO_TRASPASO: numeroTraspaso,
                TIPO_CERTIFICACION: certificacion.tipoCertificacionTraspaso? certificacion.tipoCertificacionTraspaso.nombre : "Traspaso",
                REEMPLAZANTE: certificacion.reemplazante
                  ? certificacion.reemplazante.apellido +
                    ', ' +
                    certificacion.reemplazante.nombre
                  : '-',
                FECHA_CREACION: certificacion.fechaCreacion
                  ? moment(certificacion.fechaCreacion).format(
                      'DD-MM-YYYY HH:mm'
                    )
                  : '-',
                ORIGEN: certificacion.origen
                  ? certificacion.origen.nombre
                  : '-',
                DESTINO: certificacion.destino
                  ? certificacion.destino.nombre
                  : '-',
                FECHA_DESDE: certificacion.fechaDesde
                  ? moment(certificacion.fechaDesde).format('DD-MM-YYYY HH:mm')
                  : '-',
                FECHA_HASTA: certificacion.fechaHasta
                  ? moment(certificacion.fechaHasta).format('DD-MM-YYYY HH:mm')
                  : '-',
                NORMATIVA: certificacion.normativa
                  ? certificacion.normativa
                  : '-',
                PAGO_VIATICOS: certificacion.pagoViaticos ? 'si' : 'no',
                ESTADO: certificacion.estado ? certificacion.estado : '-',
              };
            }
          );
          descargarCSV(
            [
              'N° Traspaso',
              'Reemplazante',
              'Fecha Creacion',
              'Origen',
              'Destino',
              'Fecha Desde',
              'Fecha Hasta',
              'Normativa',
              'Pago Viaticos',
              'Estado',
            ],
            data,
            `Certificaciones${moment(fechaInicio).format(
              'DD/MM/YYYY'
            )}-${moment(fechaFin).format('DD/MM/YYYY')}.csv`
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message:
            'Error a la hora de generar reporte de certificaciones traspasos',
        });
      });
  };

  filtrarPorEstado = async estado => {
    await this.setState(
      {
        ...this.state,
        filtroEstado: estado,
        loading: true,
      },

      () => this.buscarCantidadCertificaciones()
    );
  };

  filtrarPorOrigen = async idOrganismo => {
    this.setState(
      {
        ...this.state,
        filtroOrigen: idOrganismo,
        loading: true,
      },
      () => this.buscarCantidadCertificaciones()
    );
  };

  filtrarPorDestino = async idOrganismo => {
    this.setState(
      {
        ...this.state,
        filtroDestino: idOrganismo,
        loading: true,
      },
      () => this.buscarCantidadCertificaciones()
    );
  };

  filtrarPorNumTraspaso = async numTrapaso => {
    this.setState(
      {
        ...this.state,
        filtroNumTraspaso: numTrapaso === '' ? null : numTrapaso,
        loading: true,
      },
      () => this.buscarCantidadCertificaciones()
    );
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaFiltrada,
      [
        certificacion => {
          return certificacion.fechaCreacion;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      lista: listaOrdenada,
    });
  };

  render() {
    let rangoFechas = {
      fechaInicial: this.state.fechaInicial,
      fechaFinal: this.state.fechaFinal,
    };

    return (
      <div>
        <TablaCertificacionesTraspaso
          usuario={this.props.usuario}
          history={this.props.history}
          certificacionesTraspasos={this.state.lista}
          total={this.state.cantidadTotal}
          onDelete={this.onDelete}
          cambiarPagina={this.cambiarPagina}
          tamPagina={this.state.cantidadPorPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          loadingTabla={this.state.loading}
          pagina={this.state.pagina}
          verResolucion={this.getBase64}
          onChange={this.onChangeFechas}
          rangoFechas={rangoFechas}
          descargarReporte={this.descargarReporte}
          setFiltrarEstado={this.filtrarPorEstado}
          filtroEstadoPadre={this.state.filtroEstado}
          listaOrganismos={this.props.data ? this.props.data.getOrganismos : []}
          setFiltrarOrigen={this.filtrarPorOrigen}
          filtroOrigenPadre={this.state.filtroOrigen}
          setFiltrarDestino={this.filtrarPorDestino}
          filtroDestinoPadre={this.state.filtroDestino}
          filtroNumTraspasoPadre={this.state.filtroNumTraspaso}
          setFiltrarNumTraspaso={this.filtrarPorNumTraspaso}
        />
      </div>
    );
  }
}

export default withApollo(VerCertificacionesTraspaso);
